module.exports = __webpack_public_path__ + "static/media/Hector.cea5fea6.jpg";